import React, { Component } from "react";
import "./Search.scss";
import {
  Form,
  Input,
  SearchButton,
  ButtonIcon,
  SearchWrapper
} from "./Search.style";

export default class Search extends Component {
  render() {
    const  { searchBtnClick } = this.props

    return (
      <SearchWrapper>
        <Form>
        <Input type="text"  id="inputValue" autoComplete="off" />
          <SearchButton onClick = {searchBtnClick}> 
            <ButtonIcon src="https://front.videomonster.com/images-u6yd72dy/web/whitesearch.png" alt={"search"} />
          </SearchButton>
        </Form>
      </SearchWrapper>
    );
  }
}
